/* eslint-disable no-unused-vars */
import React, { Component , useRef}  from "react";
// import { browserHistory } from 'react-router'
import { withRouter } from "react-router-dom";
import  { Redirect } from 'react-router-dom'
// import  { useRef   }  from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import validator from 'validator';
import MainLayout from "../layout/main-layout";

import { login} from '../../actions/payActions'
// import DatePicker from 'react-date-picker'
// import Moment from 'moment';
// import SignatureCanvas from 'react-signature-canvas'
// import DatePicker from "react-datepicker";
// import valid from "card-validator";
import "react-datepicker/dist/react-datepicker.css";
 class home extends Component {

    constructor(props){
        super(props);
        this.state={
            error:'',
            errors:{},
            formData:{},
            login:true,
            loading:false
        }
    }

    

    componentWillReceiveProps(nextProps) {

    console.log('nextProps ----------',nextProps); 
   
    // let history = useHistory();
  
    let result = nextProps.page_name.res.result;
    // let result = {} 
    console.log('data', result)  
    
    if(nextProps.page_name){
        this.setState({message:result.message});
        // this.setState({formData:{}})  
        this.setState({'login':result.login})
        sessionStorage.getItem('client_id')
    }
    

    console.log('session -----',sessionStorage.getItem('client_id'))
    if(result.login){
        this.props.history.push('/client-information')
        localStorage.setItem('myData', 'hello');    
       
    }
     
        
    Array.from(document.querySelectorAll("input")).forEach(
        input => (input.value = "")
        );
        
    
    
    
              
        // let element = 
    }  

   

    onChange = (e) => {  
        this.state.formData[e.target.id] = e.target.value; 
        console.log('form vlaue=>', this.state.formData);
    }

    onSubmit = (e) => {              
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;
        
        if(!fields["username"]){
            formIsValid = false;
            errors["username"] = "Please enter Client ID";
            let element = document.getElementById("username");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["password"]){
            formIsValid = false;
            errors["password"] = "Please enter password";
            let element = document.getElementById("password");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        console.log('formIsValid --- ', formIsValid)

        this.setState({errors: errors});
        
        if(formIsValid){
            // this.setState({ loading: true });  
            const newList = this.state.formData;
            console.log("newlist=>", newList);
            this.props.login(newList, this.props.history);
            this.setState({loading:false})
            console.log('hello imran');
            }

    }

    render() {
        const { login } = this.state;
        if(sessionStorage.getItem('client_id') || sessionStorage.getItem('client_id')!=null) {           
            return <Redirect to="/client-information" />
          }
        return (
            <MainLayout>
                <title>American Cell Technology</title>
                {/* <Header></Header> */}

                { (this.state.loading)?
                <div class="loading-div">
                    <div class="loading-img"><img src="images/spinner.svg" alt="" /></div>
                </div>:""}
                <div className="login-wrapper">
                    <div className="login-container">
                        <div className="login-logo-area"><img src="images/logo-main.svg" alt="" /></div>
                        <div className="login-box">
                            {!(login)?<span style={{color:'red'}}>Client ID or Password not matched, Please try again.</span>:''}                            
                            <form className="needs-validation" noValidate onSubmit={this.onSubmit}>
                                <div className="form-group">
                                <label>Client ID</label>
                                <input type="text" id="username" className="form-control" placeholder="Enter Client ID" onChange={this.onChange} />
                                <small id="userHelp" className="form-text text-muted">We'll never share your username with anyone else.</small>
                                <span style={{color: "red"}}>{this.state.errors["username"]}</span>
                                </div>
                                <div className="form-group">
                                <label>Password</label>
                                <input type="password" id="password" className="form-control" placeholder="Enter Password" onChange={this.onChange} />
                                <span style={{color: "red"}}>{this.state.errors["password"]}</span>
                                </div>
                                <div className="form-group">
                                    <button type="submit" className="btn btn-primary btn-full">Sign In</button>
                                </div>
                                
                                <div className="form-group custom-control custom-checkbox">
                                <input type="checkbox" className="custom-control-input" id="customCheck" name="example1" />
                                <label className="custom-control-label" for="customCheck">Remember me</label>
                                </div>

                                <div className="forgotpass-link">
                                    <a href="../forgot-password">Forgot Your Password?</a>
                                    <a style={{width:'45%'}} target="__blank" href="https://www.americancelltechnology.com/contact/">New Here? Contact Us to Learn More</a>
                                </div>
                                
                            </form>
                        </div>
                    </div>
                </div>
                
            </MainLayout>
        );
    }
}

home.propTypes = {
    errors: PropTypes.object.isRequired,
    error: PropTypes.object.isRequired,
    login:PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    page_name : state.pay,
    errors: state.errors,
  });


export default connect(mapStateToProps, {login})(home);
